import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { uploadDocument } from "../../backend_urls/api";
import { userApi } from "../../backend_urls/userApi";
import { UserURL } from "../../routes/user_routes/UserURL";
import BaseIcon from "../../components/svg_icons/BaseIcon";
import "../../css/pages/user_pages/UserInvoiceDashboard.css";

const UserInvoiceDashboard = () => {
    const [file, setFile] = useState(null);
    const [invoices, setInvoices] = useState([]);
    const [expandedId, setExpandedId] = useState(null);

    // Fetch invoices (manual + OCR)
    const fetchInvoices = async () => {
        try {
            const res = await userApi.getAllInvoices();
            const sorted = res.data.sort(
                (a, b) => new Date(b.created_at) - new Date(a.created_at)
            );
            setInvoices(sorted);
        } catch (error) { console.error("Error fetching invoices:", error); }
    };

    useEffect(() => { fetchInvoices(); }, []);

    const handleUpload = async () => {
        if (!file) return alert("Select a file first!");
        try {
            await uploadDocument(file);
            fetchInvoices();
            setFile(null);
        } catch (error) { console.error("Upload failed", error); }
    };

    const toggleItems = (id) => { setExpandedId(expandedId === id ? null : id); };

    const formatMoney = (value) => {
        if (!value) return "-";
        return `₹ ${parseFloat(value).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
        })}`;
    };

    const handSVG = () => {
        return (
            <>
                <BaseIcon name = "writingHand" />
                Manual
            </>
        );
    };

    const getSourceBadge = (source) => {
        if (source === "upload") return "📄 OCR";
        if (source === "manual") return handSVG();
        return "-";
    };

    return (
        <div style={{ padding: "2rem" }}>
            <Link to={UserURL.USER_DASHBOARD}>Home</Link>
            <h2>Invoice Dashboard</h2>

            {/* Upload Section */}
            <input
                type="file"
                onChange={(e) => setFile(e.target.files[0])}
                accept=".pdf,.jpg,.jpeg,.png"
            />
            <button onClick={handleUpload}>Upload Invoice</button>
            <br />
            <br />
            <Link to={UserURL.USER_CREATE_MANUAL_ENTRY}>Create Manual Invoice</Link>

            <h3 style={{ marginTop: "2rem" }}>Invoices</h3>

            <table border="1" cellPadding="10" width="100%">
                <thead>
                    <tr>
                        <th>Invoice</th>
                        <th>Date</th>
                        <th>Buyer GST</th>
                        <th>Total</th>
                        <th>Source</th>
                        <th>Items</th>
                        <th>File</th>
                        <th>Edit</th>
                    </tr>
                </thead>
                <tbody>
                    {invoices.length > 0 ? (
                        invoices.map((invoice) => (
                            <React.Fragment key={invoice.id}>
                                <tr>
                                    <td>{invoice.invoice_number || "-"}</td>
                                    <td>{invoice.invoice_date || "-"}</td>
                                    <td>{invoice.buyer_gstin || "-"}</td>
                                    <td>{formatMoney(invoice.grand_total)}</td>
                                    <td>{getSourceBadge(invoice.source)}</td>
                                    <td>
                                        <button
                                            onClick={() => toggleItems(invoice.id) }
                                        >
                                            {expandedId === invoice.id ? "Hide" : "View"}
                                        </button>
                                    </td>

                                    <td>
                                        {invoice.document ? (
                                            <a
                                                href={invoice.document.file}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                View
                                            </a>
                                        ) : (
                                            "-"
                                        )}
                                    </td>

                                    <td>
                                        <Link
                                            to={UserURL.user_invoice_edit(
                                                invoice.id
                                            )}
                                        >
                                            Edit
                                        </Link>
                                    </td>
                                </tr>

                                {/* Expanded Line Items */}
                                {expandedId === invoice.id && (
                                    <tr>
                                        <td colSpan="8">
                                            <table
                                                border="1"
                                                width="100%"
                                                cellPadding="8"
                                            >
                                                <thead>
                                                    <tr>
                                                        <th>Description</th>
                                                        <th>HSN</th>
                                                        <th>Qty</th>
                                                        <th>Rate</th>
                                                        <th>Tax</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {invoice.line_items?.map(
                                                        (item) => (
                                                            <tr key={item.id}>
                                                                <td>
                                                                    {
                                                                        item.description
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {item.hsn_sac ||
                                                                        "-"}
                                                                </td>

                                                                <td>
                                                                    {item.quantity ||
                                                                        "-"}
                                                                </td>

                                                                <td>
                                                                    {formatMoney(
                                                                        item.rate
                                                                    )}
                                                                </td>

                                                                <td>
                                                                    {formatMoney(
                                                                        item.igst_amount ||
                                                                            item.cgst_amount ||
                                                                            item.sgst_amount
                                                                    )}
                                                                </td>

                                                                <td>
                                                                    {formatMoney(
                                                                        item.line_total
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="8">
                                No invoices available.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default UserInvoiceDashboard;
